import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
/**
 *  Home Page Popup Modal
 */

import colors from "./colors";
import ReactHTMLParser from "react-html-parser";
class AboutModal extends Component {
  render() {
    // console.log(this.props)
    return (
      <MDBContainer >
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal1}
          toggle={this.props.toggle1}
          centered
          backdrop={false}
          size="lg"
      //     style={{
      //   textAlign: "justify",
      //   width: window.innerWidth<1000?"250px":"600px",
      
      //   overflow: "scroll",
      // }}
        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.props.toggle1}
            style={{ background: "#3f51b5", color: "white" }}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody
            style={{
              textAlign: "justify",
              height: window.innerHeight>1000?"500px":"300px",
            
              overflow: "scroll",
            }}
          >
            a) Data Information
1.	Name of the Dataset	Glacial_Lakes_Himachal_Pradesh
2.	Keywords	Glacial Lake, Satellite Remote Sensing, Inventory,Indian Himalayan Rivers
3.	Access Constraints	Registered users
4.	Use Constraints	As per NRSC/National Hydrology Projectdata dissemination policy
5.	Purpose of creating data	Glacial lake inventory database for catchment areas of Indian Himalayan river basins
6.	Edition	First
7.	Metadata Stamp	May 2021
8.	Dataset Format	Shapefile (*.shp)

            


          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              onClick={this.props.toggle1}
              style={{ backgroundColor: "#3f51b5" }}
            >
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default AboutModal;
